<template>
  <div>
    <title-report title="Relatórios"></title-report>
    <daily-amount></daily-amount>
    <filter-report></filter-report>
    <chart-filter-container></chart-filter-container>
    <open-dialog-export-report></open-dialog-export-report>
    <open-dialog-request-report></open-dialog-request-report>
  </div>
</template>

<script>
import ChartFilterContainer from "./report/ChartFilterContainer";
import Title from "../geral/Title";
import DailyAmount from "./report/DailyAmount";
import FilterReport from "./report/filter_components/FilterReport";

import OpenDialogExportReport from "@/components/dashboard/enterprise/tools/OpenDialogExportReport";
import OpenDialogRequestReport from "@/components/dashboard/enterprise/tools/OpenDialogRequestReport";
export default {
  name: "Reports",
  components: {
    OpenDialogRequestReport,
    OpenDialogExportReport,
    ChartFilterContainer,
    FilterReport,
    DailyAmount,
    "title-report": Title
  },
};
</script>

<style scoped></style>
